import React, { useEffect, useRef, useState } from "react"
import parse, { domToReact } from "html-react-parser"
import slugify from "slugify"
import { twMerge } from "tailwind-merge"
import { useLocation } from "@reach/router"
function PostContent({ content, title }) {
    const [loaded, setLoaded] = useState(false)
    const location = useLocation()
    let currentHash = location.hash.split("#")
    let [currentSlug, setSlug] = useState(currentHash[1])
    const config = {
        replace(domNode) {
            let contentMap = []
            if (domNode.name === "h2") {
                let slug = domNode?.children[0]?.data
                    ? slugify(domNode?.children[0]?.data, "-")
                    : slugify(
                          domNode?.children[0]?.children[0]?.data || "",
                          "-"
                      )
                return (
                    <h2 className="wp-block-heading" id={slug}>
                        {domToReact(domNode.children, config)}
                    </h2>
                )
            }
        }
    }
    useEffect(() => {
        setLoaded(true)
    }, [])

    useEffect(() => {
        const displayImg = () => {
            const t = document.querySelectorAll("img[data-gatsby-image-ssr]")
            for (let e of t) {
                e.setAttribute("src", e.dataset.src)
                // e.removeAttribute("data-src")
                e.setAttribute("srcset", e.dataset.srcset)
                // e.removeAttribute("data-srcset")

                const t = e.parentNode.querySelectorAll("source[data-srcset]")
                for (let e of t) {
                    e.setAttribute("srcset", e.dataset.srcset)
                    e.removeAttribute("data-srcset")
                    e.style.opacity = 1
                    e.parentNode.parentNode.querySelector(
                        "[data-placeholder-image]"
                    ).style.opacity = 0
                }
            }
        }
        displayImg()
        let timer = setTimeout(() => displayImg(), 2000)
        return () => {
            clearTimeout(timer)
        }
    }, [loaded])

    const contentRef = useRef(null)
    const [toc, setToc] = useState([])
    useEffect(() => {
        if (contentRef.current) {
            // Select all h2 elements inside the blog content
            const headings = contentRef.current.querySelectorAll(
                "h2.wp-block-heading"
            )
            const tocItems = []

            headings.forEach(heading => {
                const text = heading.textContent || heading.innerText
                const id = slugify(text || "")

                if (text) {
                    tocItems.push({ id, text })
                }
            })

            setToc(tocItems)
        }
    }, [content])
    return (
        <div
            ref={contentRef}
            className="blog-post-content mt-5 px-5 font-['Work_Sans'] text-sm leading-[22px] lg:text-[18px] lg:leading-9"
        >
            <h1 className="mb-6 text-[1.875rem] font-bold leading-[2.25rem]">
                {title}
            </h1>
            {parse(content, config)}
        </div>
    )
}

export default PostContent
